import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-dcd281fa"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "top",
  id: "content"
};
var _hoisted_2 = ["src"];

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "banner_title"
  }, [/*#__PURE__*/_createTextVNode(" 百城愿景 "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 成为一流的儿童健康阅读服务商 ")], -1);
});

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "banner_abs"
  }, " BECOME A FIRST-CLASS CHILDREN'S READING HEALTH SERVICE PROVIDER.I HOPE EVERY CHILD WILL LOVE READING ", -1);
});

var _hoisted_5 = {
  class: "block"
};

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "block_title"
  }, "RELATED INFORMATION", -1);
});

var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "block_title2"
  }, "相关资讯", -1);
});

var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "block_border"
  }, null, -1);
});

var _hoisted_9 = {
  class: "tabs"
};
var _hoisted_10 = {
  key: 0,
  class: "news"
};
var _hoisted_11 = ["onClick"];
var _hoisted_12 = {
  class: "news_title"
};
var _hoisted_13 = {
  key: 1,
  class: "news"
};

var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "news_item"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "news_title"
  }, "基于健康显示技术的彩色儿童数字读本在杭州发布"), /*#__PURE__*/_createElementVNode("div", null, "2022-01-04")], -1);
});

var _hoisted_15 = [_hoisted_14];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_carousel_item = _resolveComponent("el-carousel-item");

  var _component_el_carousel = _resolveComponent("el-carousel");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_carousel, {
    interval: 5000,
    loop: "true"
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bannerList, function (item) {
        return _openBlock(), _createBlock(_component_el_carousel_item, {
          key: item
        }, {
          default: _withCtx(function () {
            return [_createElementVNode("img", {
              src: item.url,
              class: "banner"
            }, null, 8, _hoisted_2), _hoisted_3, _hoisted_4];
          }),
          _: 2
        }, 1024);
      }), 128))];
    }),
    _: 1
  })]), _createElementVNode("div", _hoisted_5, [_hoisted_6, _hoisted_7, _hoisted_8, _createElementVNode("div", _hoisted_9, [_createElementVNode("div", {
    class: _normalizeClass(_ctx.active == 0 ? 'tab1' : 'tab2'),
    onClick: _cache[0] || (_cache[0] = function () {
      return _ctx.gotoBaicheng && _ctx.gotoBaicheng.apply(_ctx, arguments);
    })
  }, "百城资讯", 2), _createElementVNode("div", {
    class: _normalizeClass(_ctx.active == 1 ? 'tab1' : 'tab2'),
    onClick: _cache[1] || (_cache[1] = function () {
      return _ctx.gotoYejie && _ctx.gotoYejie.apply(_ctx, arguments);
    })
  }, "业界资讯", 2)]), _ctx.active == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataList, function (item, index) {
    return _openBlock(), _createElementBlock("div", {
      key: index
    }, [_createElementVNode("div", {
      class: "news_item",
      onClick: function onClick($event) {
        return _ctx.handleNewsdetail(item.news_id);
      }
    }, [_createElementVNode("div", _hoisted_12, _toDisplayString(item.news_title), 1), _createElementVNode("div", null, _toDisplayString(item.sub_title), 1)], 8, _hoisted_11)]);
  }), 128))])) : _createCommentVNode("", true), _ctx.active == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15)) : _createCommentVNode("", true)])], 64);
}